export const delivery = 'delivery';
export const defaultWorkTime = 'default-work-time';
export const schedule = 'schedule';
export const departments = 'departments';
export const websiteMeta = 'website-meta';
export const tablesSettings = 'tables-settings';
export const agents = 'agents';
export const employees = 'employees';
export const popularity = 'popularity'; 
export const faqs = 'faqs';
export const reviews = 'reviews';
export const promo = 'promo';
export const news = 'news';
export const counter = 'counter/sms';
export const sms = 'sms/limit';
export const documents = 'documents';


// WEBPACK FOOTER //
// ./src/constants/settingTypes.js